import { render, staticRenderFns } from "./PickupRequestList.vue?vue&type=template&id=dfd7499e&"
import script from "./PickupRequestList.vue?vue&type=script&lang=js&"
export * from "./PickupRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports